import type React from "react";
import { DealMainWorkflowVendorSub } from "~/components/common/deals/show/main/DealMainWorkflowVendorSub";
import { PartnerAssignmentResponseForm } from "~/components/common/deals/show/main/PartnerAssignmentResponseForm";
import { StatusBar } from "~/components/common/parts/status/StatusBar";
import { StatusReasonCard } from "~/components/common/statuses/StatusReasonCard";
import { StatusSwitcher } from "~/components/specifics/vendors/deals/[id]/statuses/StatusSwitcher";
import { DealContextProvider } from "~/context/DealContext";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import { useDeals } from "~/hooks/vendors/useDeals";
import { useSessions } from "~/hooks/vendors/useSessions";
import { useStatuses } from "~/hooks/vendors/useStatuses";
import {
	getOriginVendor,
	getSelfDealVendor,
	isOriginVendor
} from "~/models/DealVendorCompany";
import {
	getWithVendorStatuses,
	isCancelApplying,
	isCanceled,
	NOW_ACCEPTING
} from "~/models/Status";
import Styles from "./DealMainWorkflow.module.scss";
import { DealMainWorkflowVendorCancel } from "./DealMainWorkflowVendorCancel";

export const DealMainWorkflowVendor: React.FC = () => {
	const id = useIdQueryHandler();
	const { data: deal, mutate: mutateDeal } = useDeals().show(id);
	const { data: statuses } = useStatuses().index();
	const { data: session } = useSessions().index();
	if (deal === null || session === null) {
		return null;
	}

	const isSubVendor = !isOriginVendor(deal, session.vendorCompany.id);
	const selfDealVendor = getSelfDealVendor(deal, session.vendorCompany.id);
	const isPendingAssignment =
		selfDealVendor?.itandiPartnerAssignmentStatus === "pending";
	if (isCancelApplying(deal)) {
		return <DealMainWorkflowVendorCancel isSubVendor={isSubVendor} />;
	}
	if (statuses === null) {
		return <></>;
	}
	const displayStatuses = getWithVendorStatuses(statuses);
	return (
		<DealContextProvider deal={deal}>
			{!isCanceled(deal.statusId) && (
				<>
					<div className={Styles.StatusCard}>
						<h2 className={Styles.Header}>
							{deal.companySetting.name}からの依頼
						</h2>
						{isSubVendor ? (
							<h4 className={Styles.SubVendorLabel}>
								施工会社：{getOriginVendor(deal)?.name}
							</h4>
						) : null}
						<StatusBar currentId={deal.statusId} statuses={displayStatuses} />
					</div>
					{deal.statusId !== NOW_ACCEPTING && <DealMainWorkflowVendorSub />}
				</>
			)}
			<StatusReasonCard deal={deal} />
			<div className={Styles.WorkflowCard}>
				{isSubVendor && isPendingAssignment ? (
					<PartnerAssignmentResponseForm
						dealId={deal.id}
						mutateDeal={mutateDeal}
					/>
				) : (
					<StatusSwitcher statusId={deal.statusId} />
				)}
			</div>
		</DealContextProvider>
	);
};
